import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { norfolkConfig } from "./data";

export default function NorfolkPage() {
  return <CityPageTemplate config={norfolkConfig} />;
}